import { commonServicesPlugin } from '../common-services';
import { clientLocationPlugin } from '../client-location';
export function clientPlugin(location) {
  return function (router) {
    router.plugin(commonServicesPlugin());
    router.plugin(clientLocationPlugin(location));
    return {
      name: 'WixUIRouterClient'
    };
  };
}
//# sourceMappingURL=plugin.js.map